// Rows that scroll themselves carry SELF_SCROLL_ATTR: the home page's NEW
// ARRIVALS, which drifts on its own and never stops (HomePage's arrivals
// effect). Page-wide scroll listeners that mean "the visitor is scrolling"
// (the card hover guard in hoverRest, the cart overlay's close) leave those
// rows' scroll events out. The drift fires one every frame: it would keep
// every card on the page out of its hover, and close the cart overlay the
// moment it opened.
export const SELF_SCROLL_ATTR = "data-self-scroll";

/** True when a scroll event came from a row that scrolls itself. */
export function isSelfScroll(e) {
  return e.target instanceof Element && e.target.hasAttribute(SELF_SCROLL_ATTR);
}
